import React, { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Divider, Input, Select, Button, Checkbox } from "antd";
import Utils from "../../utils";
import AddressAutocomplete from "../AddressAutocomplete/AddressAutocomplete";

export default function ShippingSelect({
  token,
  className,
  addBtnText,
  placeholder,
  options,
  addItem,
  loading,
  selectedItem,
  setSelectedItem,
  error,
  resetError,
}) {
  const emptyDetails = {
    city: "",
    address1: "",
    state: "",
    zipcode: "",
    latitude: null,
    longitude: null,
  };
  const [details, setDetails] = useState(emptyDetails);
  const onDetailChnage = (key, value) => {
    setDetails({
      ...details,
      [key]: value,
    });
  };

  const [isNew, setIsNew] = useState(false);
  return (
    <Select
      className={className ? className : ""}
      style={{
        width: "100%",
        backgroundColor: token?.Card?.colorBgCard,
      }}
      placeholder={placeholder}
      disabled={loading}
      loading={loading}
      status={error ? "error" : null}
      value={selectedItem ? Utils?.getDisplayAddress(selectedItem) : null}
      onChange={(val) => {
        const foundAddress = options?.find((el) => el?.id === val);
        setSelectedItem(foundAddress);
        if (error) {
          resetError();
        }
      }}
      popupRender={(menu) => (
        <div
          style={{
            width: "100%",
          }}>
          {menu}
          <Divider
            style={{
              margin: "8px 0",
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}>
            <Checkbox
              onChange={() => {
                setIsNew(!isNew);
              }}
              checked={isNew}>
              New shipping address
            </Checkbox>
            {isNew ? (
              <>
                <AddressAutocomplete
                  placeholder="Address (autofills City, State, Zip below)"
                  value={details?.address1}
                  onChange={(val) => {
                    // Typed text may no longer match the picked pin, so drop
                    // it; a suggestion pick restores it in onAddressSelect.
                    setDetails((prev) => ({
                      ...prev,
                      address1: val,
                      latitude: null,
                      longitude: null,
                    }));
                  }}
                  onAddressSelect={({
                    street,
                    city,
                    state,
                    zipcode,
                    latitude,
                    longitude,
                  }) => {
                    setDetails((prev) => ({
                      ...prev,
                      address1: street,
                      city,
                      state,
                      zipcode,
                      latitude: latitude ?? null,
                      longitude: longitude ?? null,
                    }));
                  }}
                  size="small"
                  inputProps={{
                    style: {
                      width: "100%",
                      backgroundColor: token?.Card?.colorBgCard,
                    },
                    onKeyDown: (e) => e.stopPropagation(),
                  }}
                />
                <Input
                  style={{
                    width: "100%",
                    backgroundColor: token?.Card?.colorBgCard,
                  }}
                  placeholder="City"
                  value={details?.city}
                  onChange={(e) => {
                    onDetailChnage("city", e?.target?.value);
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  size="small"
                />
                <Input
                  style={{
                    width: "100%",
                    backgroundColor: token?.Card?.colorBgCard,
                  }}
                  placeholder="State"
                  value={details?.state}
                  onChange={(e) => {
                    onDetailChnage("state", e?.target?.value);
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  size="small"
                />
                <Input
                  style={{
                    width: "100%",
                    backgroundColor: token?.Card?.colorBgCard,
                  }}
                  placeholder="Zip code"
                  value={details?.zipcode}
                  onChange={(e) => {
                    if (e.target.value?.length <= 10) {
                      onDetailChnage("zipcode", e?.target?.value);
                    }
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  size="small"
                />
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    addItem(details);
                    setDetails(emptyDetails);
                    setIsNew(false);
                  }}
                  disabled={
                    !details?.state ||
                    !details?.city ||
                    !details?.address1 ||
                    !details?.zipcode ||
                    loading
                  }
                  size="small">
                  {addBtnText}
                </Button>
              </>
            ) : null}
          </div>
        </div>
      )}
      options={options?.map((item) => ({
        label: Utils?.getDisplayAddress(item),
        value: item?.id,
      }))}
    />
  );
}
